import { connectedStore } from '../../store';
import selectors from '../selectors';

const getPage = (pageId) => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getPage(state, pageId);
};

export default getPage;
